<template>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12" class="text-center">
            <v-text-field
              type="text"
              v-model="object.nombre"
              label="Nombre"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!detalle" color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      nombre: this.object.nombre,
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
    detalle: Boolean,
  },
  computed: {
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edición de registro";
      } else if (me.detalle) {
        titulo = "Detalle";
      } else {
        titulo = "Nuevo registro";
      }
      // this.update ? "Edución de registro" : "Nuevo registro";
      return titulo;
    },
  },
  methods: {
    guardar() {
      this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
